import React, {useState, useRef} from 'react';
import {Modal, Carousel, Button} from 'antd';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import classes from './News.module.scss';
import Navbar from "../Navbar/Navbar";
import Fotter from "../Fotter/Fotter";


function News() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImages, setCurrentImages] = useState([]);
    const carouselRef = useRef(null);


    const dubaiImages = [
        'https://i.imgur.com/19KJFMg.jpeg',
        'https://i.imgur.com/flTZiGd.jpeg',
        'https://i.imgur.com/Icqi3xk.jpeg',
        'https://i.imgur.com/P4Lqpuk.jpeg',
        'https://i.imgur.com/xZyR1eM.jpeg',
        'https://i.imgur.com/dOFtYPf.jpeg',
        'https://i.imgur.com/ag6q0xK.jpeg',
    ];

    const umexImages = [
        'https://i.imgur.com/BTdl697.jpeg',
        'https://i.imgur.com/9TGPuNJ.jpeg',
        'https://i.imgur.com/wt70cwH.jpeg',
        'https://i.imgur.com/BWvilCl.jpeg',
        'https://i.imgur.com/rQO5QrF.jpeg',
        'https://i.imgur.com/3c0fr8x.jpeg',
        'https://i.imgur.com/AzOCSHQ.jpeg',
        'https://i.imgur.com/jL5palR.jpeg',
        'https://i.imgur.com/8F7xzd1.jpeg',
        'https://i.imgur.com/NXoO8qV.jpeg',
        'https://i.imgur.com/sfNUjF8.jpeg',
    ];

    const uaeImages = [
        'https://i.imgur.com/n5yVaUA.jpeg',
        'https://i.imgur.com/HU5SBPx.jpeg',
        'https://i.imgur.com/8Jt0Bvh.jpeg',
        'https://i.imgur.com/nMByvRR.jpeg',
        'https://i.imgur.com/ETNZyIw.jpeg',
        'https://i.imgur.com/bC2LKXf.jpeg',
        'https://i.imgur.com/pSqFI5F.jpeg',
        'https://i.imgur.com/DDz9Oa7.jpeg',
        'https://i.imgur.com/FstMSMA.jpeg',
        'https://i.imgur.com/uh76LiK.jpeg',
        'https://i.imgur.com/qb61un6.jpeg',
    ]


    const deffaImages = [
        'https://i.imgur.com/cbF5R45.jpeg',
        'https://i.imgur.com/wy9czZQ.jpeg',
        'https://i.imgur.com/vRXVdTF.jpeg',
        'https://i.imgur.com/u023xRW.jpeg',
        'https://i.imgur.com/lioh9yB.jpeg'
    ]

    const dubaiImagTwoes = [
        'https://i.imgur.com/FtzbUiw.jpeg',
        'https://i.imgur.com/6fozLf2.jpeg',
        'https://i.imgur.com/fRSzuFG.jpeg',
        'https://i.imgur.com/OYhwCLc.jpeg',
        'https://i.imgur.com/IiGimSh.jpeg',
        'https://i.imgur.com/lXDLFl3.jpeg',
        'https://i.imgur.com/2fWut9i.jpeg',
        'https://i.imgur.com/4JIxfJm.jpeg',
        'https://i.imgur.com/SpWWWJm.jpeg',
        'https://i.imgur.com/vQ8tOiL.jpeg'
    ]


    const umexImagesAbudabi = [
        'https://i.imgur.com/ilaGaUD.jpeg',
        'https://i.imgur.com/8pIASmu.jpeg',
        'https://i.imgur.com/YCGsBUy.jpeg',
        'https://i.imgur.com/u6jSlmt.jpeg',
        'https://i.imgur.com/4JFsMh3.jpeg',
        'https://i.imgur.com/qe6JQun.jpeg',
        'https://i.imgur.com/jhl0clg.jpeg',
        'https://i.imgur.com/dU7Dp5Y.jpeg',
        'https://i.imgur.com/hBWZSyz.jpeg',
        'https://i.imgur.com/WCunHbX.jpeg',
        'https://i.imgur.com/4Vcleh8.jpeg',
    ]


    const chinaImages = [
        'https://i.imgur.com/Vnd4kcG.jpeg',
        'https://i.imgur.com/4UY4fXx.jpeg',
        'https://i.imgur.com/dHnSqcD.jpeg',
        'https://i.imgur.com/YFYWqRl.jpeg',
        'https://i.imgur.com/VShb6a9.jpeg',
        'https://i.imgur.com/O7eIuYF.jpeg',
        'https://i.imgur.com/3Gi6AIP.jpeg',
        'https://i.imgur.com/9rwBISP.jpeg',
        'https://i.imgur.com/VXEomXa.jpeg',
        'https://i.imgur.com/YsNgWdT.jpeg'

    ]


    const parisImages = [
        'https://i.imgur.com/lmbfqGQ.jpeg',
        'https://i.imgur.com/BvYfaK1.jpeg',
        'https://i.imgur.com/CDCFffT.jpeg',
        'https://i.imgur.com/asFTc7h.jpeg',
        'https://i.imgur.com/M3qgJWA.jpeg',
        'https://i.imgur.com/NCSyypy.jpeg',
        'https://i.imgur.com/O4oMDw5.jpeg',
        'https://i.imgur.com/faoh7fl.jpeg',
        'https://i.imgur.com/Pupm0iY.jpeg',
        'https://i.imgur.com/smBvPLo.jpeg',
        'https://i.imgur.com/dM2GAks.jpeg',
        'https://i.imgur.com/L1yLuOz.jpeg',

    ]


    const demirchyanImages = [
        'https://i.imgur.com/0NRE1v7.jpeg',
        'https://i.imgur.com/idmQtGy.jpeg',
        'https://i.imgur.com/Cfg7TAs.jpeg',
        'https://i.imgur.com/BifbHyb.jpeg',
        'https://i.imgur.com/Xf8Wu4g.jpeg',
        'https://i.imgur.com/JYh8vQ3.jpeg',
        'https://i.imgur.com/cxubXSg.jpeg'
    ]


    const openModal = (images) => {
        setCurrentImages(images);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handlePrev = () => {
        if (carouselRef.current) {
            carouselRef.current.prev();
        }
    };

    const handleNext = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };


    return (
        <div className={classes['news-container']}>
            <div className={classes['news-section-one']}>
                <Navbar/>
                <h2 className={classes['hh']}>NEWS AND EVENTS</h2>
            </div>


            <div className={classes['news-section-two']}>



                <div className={classes['child']}>
                    <div className={classes['umex-two-img']} onClick={() => openModal(umexImagesAbudabi)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>January 27 UMEX 2024 - Abu Dhabi</h3>
                    <p>In 2024, we’re taking things to the next level
                        with a more extensive event featuring a dedicated
                        commercial zone. This expansion aligns perfectly with
                        the global commercial unmanned sector’s immense
                        potential, making the UMEX the ideal platform to discover
                        and leverage these opportunities.</p>
                </div>

                <div className={classes['child']}>
                    <div className={classes['china-img']} onClick={() => openModal(chinaImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>May 24 China 2024</h3>
                    <p>SHENZHEN UAS Expo 2024 - March 14 Eurosatory 2024</p>
                </div>






                <div className={classes['child']}>
                    <div className={classes['paris-img']} onClick={() => openModal(parisImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>June 17 Paris 2024</h3>
                    <p>Eurosatory presents solutions, services and expertise
                        in the face of all types of often complex crises, from
                        high-intensity conflicts to humanitarian and environmental
                        disasters specific to our century.</p>
                </div>

                <div className={classes['child']}>
                    <div className={classes['abudabi-img']} onClick={() => openModal(uaeImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>February 20 Abu Dhabi, UAE 2023</h3>
                    <p>IDEX is the only international defence exhibition
                        and conference in the MENA region demonstrating
                        the latest technology across land, sea and air sectors
                        of defence.</p>
                </div>

                <div className={classes['child']}>
                    <div className={classes['deffa-img']} onClick={() => openModal(deffaImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>May 9 DEFEA 2023 Athens</h3>
                    <p>DEFEA is a high-profile international defence
                        exhibition where international companies present
                        land, naval, aerospace, national and cyber security
                        defence systems.</p>
                </div>

                <div className={classes['child']}>
                    <div className={classes['dubai-two-img']} onClick={() => openModal(dubaiImagTwoes)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>November 13 Dubai Airshow 2023</h3>
                    <p>Dubai Airshow 2023 showcased an impressive lineup
                        of the latest commercial, business, and military aircrafts,
                        along with an exciting selection of eVTOLs and helicopters
                        from both industry leaders and emerging players.</p>
                </div>




                <div className={classes['child']}>
                    <div className={classes['demirchyan-img']} onClick={() => openModal(demirchyanImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>March 31 Karen Demirchyan Sport/Complex 2022</h3>
                    <p>The purpose of the exhibition is to create a unique platform
                        to promote and study the local market, to advance modern
                        technologies and services, to find partners and investors,
                        to establish cooperative relations, to strengthen partnerships.</p>
                </div>





                <div className={classes['child']}>
                    <div className={classes['umex-img']} onClick={() => openModal(umexImages)}
                         style={{cursor: 'pointer'}}></div>
                    <h3>February 21 UMEX_SIMTEX 2022</h3>
                    <p>The UMEX 2022 was considered the fifth
                        edition of the Unmanned system exhibition
                        and conference in Abu Dhabi and the only
                        event dedicated to robotics, drones, unmanned
                        and component systems.</p>
                </div>










                <div className={classes['child']}>
                    <div
                        className={classes['dubai-img']}
                        onClick={() => openModal(dubaiImages)}
                        style={{cursor: 'pointer'}}
                    ></div>
                    <h3>November 14 Dubai Airshow 2021</h3>
                    <p>Indigo Partners placed firm orders for 255
                        A321 Neo aircraft. Jazeera Airways placed
                        an order for 28 A321 Neos. Ibom Air ordered
                        seven A350 freighters. On November 16,
                        Indian airline Akasa Air also placed an order
                        for 72 Boeing 737 MAX aircraft. Jetex was the
                        official FBO at the show.</p>
                </div>

                {/* Modal with Carousel and Prev/Next Buttons */}
                <Modal
                    open={isModalOpen}
                    onCancel={handleCancel}
                    footer={null}
                    width={800}
                >
                    <div style={{position: 'relative'}}>
                        <Carousel ref={carouselRef}>
                            {currentImages.map((img, index) => (
                                <div key={index}>
                                    <img
                                        src={img}
                                        alt={`Slide ${index + 1}`}
                                        style={{width: '100%', height: '400px', objectFit: 'cover'}}
                                    />
                                </div>
                            ))}
                        </Carousel>

                        <Button
                            shape="circle"
                            icon={<LeftOutlined/>}
                            onClick={handlePrev}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '10px',
                                transform: 'translateY(-50%)',
                                zIndex: 1000,
                            }}
                        />

                        <Button
                            shape="circle"
                            icon={<RightOutlined/>}
                            onClick={handleNext}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '10px',
                                transform: 'translateY(-50%)',
                                zIndex: 1000,
                            }}
                        />
                    </div>
                </Modal>


            </div>

            <Fotter/>
        </div>
    );
}

export default News;
